__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['unify-status-site'].baseUrl;
import ModuleContainer from './components/StatusSite';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}